<template>
  <page>
    <lazy-div>
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon v-if="newMode">mdi-plus</v-icon>
          <v-icon v-else-if="reviewMode">mdi-pencil</v-icon>
          <v-icon v-else-if="queryMode">mdi-magnify</v-icon>
          <v-toolbar-title v-if="newMode">Create Permitted Tariff </v-toolbar-title>
          <v-toolbar-title v-else-if="reviewMode">Edit Permitted Tariff</v-toolbar-title>
          <v-toolbar-title v-else-if="queryMode">Query Permitted Tariff</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <message :messages="messages"></message>
          <v-container fluid grid-list-lg>
            <!-- Business Class -->
            <v-layout v-if="newMode" row wrap>
              <v-flex xs6 v-if="!fromBusCls && fromTariff">
                <v-text-field
                  readonly
                  v-model="form.busCls"
                  :label="labels.busCls"
                  :error-messages="errors.collect('busCls')"
                  data-vv-name="busCls"
                  :data-vv-as="labels.busCls"
                  v-validate="'required|max:4|param'"
                  append-icon="mdi-magnify"
                  @click:append="getHelpList('busCls')"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{ labels.busCls }}</v-subheader>
                <div class="queryValue">{{ form.busCls }}</div>
              </v-flex>
              <v-flex xs6 v-if="!fromBusCls && fromTariff" v-show="busClsDescFromHelpList != undefined && busClsDescFromHelpList != ''">
                <v-subheader class="queryLabel">{{ labels.busClsDescFromHelpList }}</v-subheader>
                <div class="queryValue">{{ busClsDescFromHelpList }}</div>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{ labels.busClsDescFromDB }}</v-subheader>
                <div class="queryValue">{{ form.busClsDesc }}</div>
              </v-flex>
            </v-layout>
            <v-layout v-else row wrap>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.busCls }}</v-subheader>
                <div class="queryValue">{{ form.busCls }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.busClsDescFromDB }}</v-subheader>
                <div class="queryValue">{{ busClsDescFromDB }}</div>
              </v-flex>
            </v-layout>
            <!-- Tariff -->
            <v-layout row wrap v-if="!newMode">
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.tarf }}</v-subheader>
                <div class="queryValue" v-for="item in filterTarfList" :key="item.code">{{ item.code }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.tarfDesc }}</v-subheader>
                <div class="queryValue" v-for="item in filterTarfList" :key="item.code">{{ item.desc }}</div>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-else>
              <v-flex xs12 v-if="fromBusCls && !fromTariff">
                <v-autocomplete
                  :label="labels.tarf"
                  :items="tarfList"
                  v-model="form.tarf"
                  item-text="value"
                  item-value="code"
                  data-vv-name="tarf"
                  :data-vv-as="labels.tarf"
                  :error-messages="errors.collect('tarf')"
                  v-validate="'required'"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6 v-if="!fromBusCls && fromTariff">
                <v-subheader class="queryLabel">{{ labels.tarf }}</v-subheader>
                <div class="queryValue">{{ form.tarf }}</div>
              </v-flex>
              <v-flex xs6 v-if="!fromBusCls && fromTariff">
                <v-subheader class="queryLabel">{{ labels.tarfDesc }}</v-subheader>
                <div class="queryValue">{{ form.tarfDesc }}</div>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex xs12 md6 v-if="queryMode">
                <v-checkbox readonly v-model="form.vehRegMand" :label="labels.vehRegMand"></v-checkbox>
              </v-flex>
              <v-flex xs12 md6 v-else>
                <v-checkbox
                  v-model="form.vehRegMand"
                  :label="labels.vehRegMand"
                  :error-messages="errors.collect('vehRegMand')"
                  data-vv-name="vehRegMand"
                  :data-vv-as="labels.vehRegMand"
                  v-validate="'required'"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12 md6 v-if="queryMode">
                <v-checkbox readonly v-model="form.namedDrvMand" :label="labels.namedDrvMand"></v-checkbox>
              </v-flex>
              <v-flex xs12 md6 v-else>
                <v-checkbox
                  v-model="form.namedDrvMand"
                  :label="labels.namedDrvMand"
                  :error-messages="errors.collect('namedDrvMand')"
                  data-vv-name="namedDrvMand"
                  :data-vv-as="labels.namedDrvMand"
                  v-validate="'required'"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12 md6 v-if="queryMode">
                <v-checkbox readonly v-model="form.vehValMand" :label="labels.vehValMand"></v-checkbox>
              </v-flex>
              <v-flex xs12 md6 v-else>
                <v-checkbox
                  v-model="form.vehValMand"
                  :label="labels.vehValMand"
                  :error-messages="errors.collect('vehValMand')"
                  data-vv-name="vehValMand"
                  :data-vv-as="labels.vehValMand"
                  v-validate="'required'"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12 md6 v-if="queryMode">
                <v-checkbox readonly v-model="form.makeModMand" :label="labels.makeModMand"></v-checkbox>
              </v-flex>
              <v-flex xs12 md6 v-else>
                <v-checkbox
                  v-model="form.makeModMand"
                  :label="labels.makeModMand"
                  :error-messages="errors.collect('makeModMand')"
                  data-vv-name="makeModMand"
                  :data-vv-as="labels.makeModMand"
                  v-validate="'required'"
                ></v-checkbox>
              </v-flex>
            </v-layout>
          </v-container>
          <v-container fluid grid-list-lg>
            <v-layout>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
                <div class="queryValue">{{ createdBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(createdDate) }}</div>
              </v-flex>
            </v-layout>
            <v-layout v-if="!newMode">
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
                <div class="queryValue">{{ modifiedBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(modifiedDate) }}</div>
              </v-flex>
            </v-layout>
          </v-container>
          <v-container fluid grid-list-lg>
            <v-btn class="mr-2 mt-2" color="error" @click="doCancel" :loading="submitting">
              <span>Cancel</span>
              <v-icon right dark>mdi-cancel</v-icon>
            </v-btn>
            <v-btn class="mt-2" :disabled="queryMode" color="primary" dark @click="doSave" :loading="submitting">
              Save
              <v-icon right dark>mdi-content-save</v-icon>
            </v-btn>
          </v-container>
          <v-dialog v-model="busClsList" width="900px" persistent>
            <busCls-help-list v-if="busClsHelpList" :bc="form.busCls" @close="doClose" @doAssign="doAssign($event)"></busCls-help-list>
          </v-dialog>
        </v-card-text>
      </v-card>
    </lazy-div>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'
import BusClsHelpList from './BusClsHelpList.vue'
export default {
  data() {
    return {
      labels: {
        busCls: 'Business Class',
        busClsDescFromHelpList: 'Business Class Description',
        busClsDescFromDB: 'Business Class Description',
        tarf: 'Tariff',
        tarfDesc: 'Tariff Description',
        vehRegMand: 'Is Vehicle Registration No. Mandatory?',
        vehValMand: 'Is Vehicle Value Mandatory?',
        namedDrvMand: 'Is Named Driver Mandatory?',
        makeModMand: 'Is Make Model Mandatory?',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      form: {
        busCls: '',
        busClsDesc: '',
        tarf: '',
        tarfDesc: '',
        vehRegMand: false,
        vehValMand: false,
        namedDrvMand: false,
        makeModMand: false
      },
      tarfList: [],
      newMode: false,
      queryMode: false,
      reviewMode: false,
      submitting: false,
      createdBy: this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName,
      createdDate: new Date(),
      modifiedBy: '',
      modifiedDate: undefined,
      fromBusCls: false,
      fromTariff: false,
      busClsDescFromHelpList: '',
      busClsDescFromDB: '',
      busClsList: false,
      busClsHelpList: false
    }
  },
  methods: {
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    },
    async doFetch() {
      const apiURI = this.menu.getPmtTariffPerBusCls
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.objParam)
          const { data } = result.data
          if (data) {
            this.form.busCls = data.permittedTariff.busCls
            this.form.tarf = data.permittedTariff.tarf
            this.form.vehRegMand = data.permittedTariff.vehRegMand
            this.form.vehValMand = data.permittedTariff.vehValMand
            this.form.namedDrvMand = data.permittedTariff.namedDrvMand
            this.form.makeModMand = data.permittedTariff.makeModMand
            this.busClsDescFromDB = data.permittedTariff.busClsDesc
            this.createdBy = data.createdBy
            this.createdDate = data.createdDate
            this.modifiedBy = data.modifiedBy
            this.modifiedDate = data.modifiedDate
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    getAllTarfAndDesc() {
      const apiURI = this.menu.getTarfList
      if (apiURI) {
        this.submitting = true
        this.$http
          .get(apiURI)
          .then((result) => {
            this.tarfList = []
            const { data } = result.data
            if (data) {
              data.map((tarfMap) => {
                const convertList = {
                  code: tarfMap.tarf,
                  value: tarfMap.tarf + ' - ' + tarfMap.tarfDesc,
                  desc: tarfMap.tarfDesc
                }
                this.tarfList.push(convertList)
              })
            }
            this.submitting = false
          })
          .catch((err) => {
            this.submitting = false
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    doCancel() {
      this.$router.push({
        name: 'pmtTariffPerBusCls',
        params: {
          incomingBusCls: this.fromBusCls ? this.objParam.busCls : 'noBusCls',
          incomingTariff: this.fromTariff ? this.objParam.tarf : 'noTariff',
          incomingBusClsDesc: this.fromBusCls ? this.objParam.busClsDesc : 'noBusClsDesc',
          incomingTariffDesc: this.fromTariff ? this.objParam.tarfDesc : 'noTariffDesc'
        }
      })
    },
    doSave() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newMode) {
            this.doCreate()
          } else if (this.reviewMode) {
            this.doUpdate()
            // } else {
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.menu.createPmtTariffPerBusCls
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.form)
          const { data } = result
          if (data) {
            this.notify(data)
            this.message(data)
            this.fieldMessage(data)
            this.doCancel()
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      const apiURI = this.menu.updatePmtTariffPerBusCls
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.form)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doCancel()
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response.data
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    getHelpList(fieldName) {
      if (fieldName === 'busCls') {
        this.busClsHelpList = true
        this.busClsList = true
      }
    },
    doClose() {
      this.busClsHelpList = false
      this.busClsList = false
    },
    doAssign(Obj) {
      if (Obj.from === 'busCls') {
        this.form.busCls = Obj.busCls.busCls
        this.busClsDescFromHelpList = Obj.busCls.busClsDesc
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.pmtTariffPerBusClsParam.menu
    },
    modeParam() {
      return this.$route.params.pmtTariffPerBusClsMode
    },
    objParam() {
      return this.$route.params.pmtTariffPerBusClsObjRes
    },
    fromWhere() {
      return this.$route.params.fromWhere
    },
    filterTarfList() {
      return this.tarfList.filter((list) => {
        return list.code === this.form.tarf
      })
    }
  },
  watch: {},
  mounted() {},
  created() {
    this.getAllTarfAndDesc()
    if (this.modeParam === 'create') {
      this.newMode = true
    } else if (!this.modeParam) {
      this.doCancel()
    } else {
      if (this.modeParam === 'query') {
        this.queryMode = true
      } else if (this.modeParam === 'review') {
        this.reviewMode = true
      }
      this.doFetch()
    }
    if (this.fromWhere === 'fromBusCls') {
      this.fromBusCls = true
      this.fromTariff = false
      if (this.newMode) {
        this.form.busCls = this.objParam.busCls
        this.form.busClsDesc = this.objParam.busClsDesc
      }
    } else if (this.fromWhere === 'fromTariff') {
      this.fromBusCls = false
      this.fromTariff = true
      if (this.newMode) {
        this.form.tarf = this.objParam.tarf
        this.form.tarfDesc = this.objParam.tarfDesc
      }
    }
  },
  mixins: [MessageMixin],
  components: {
    BusClsHelpList
  }
}
</script>
